// @ts-nocheck

import { DayPickerRangeController } from 'react-dates'

// Globally disable `CalendarDay__before_hovered_end` class name from being
// added to react-dates calendar days - this styling is not used by our calendar
// implementation and introduces problems due to bugs in the react-dates
// implementation, e.g. when selecting the already-selected end date as the new
// start date it causes the days before the end date to become stuck in the
// "hovered" state.
//
// By overriding the prototype of the class component we can make attempts by
// the component to set those styles to be a no-op:

DayPickerRangeController.prototype.isDayBeforeHoveredEndDate = function customDayBeforeHoveredEndDate() {
  return false
}
const originalAddModifierToRange =
  DayPickerRangeController.prototype.addModifierToRange

DayPickerRangeController.prototype.addModifierToRange = function customAddModifierToRange(
  updatedDays,
  start,
  end,
  modifier
) {
  if (modifier === 'before-hovered-end') {
    return updatedDays
  }
  return originalAddModifierToRange.call(
    this,
    updatedDays,
    start,
    end,
    modifier
  )
}
